import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  useTheme,
} from "@mui/material";
import axios from "axios";
import ConfirmDialogPaymentMethod from "../global/ConfirmDialogPaymentMethod";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import { Grid, TextField } from "@material-ui/core";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import ReplayIcon from "@mui/icons-material/Replay";

import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import packageJson from "../../../../package.json";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import { getEPaymentConfig } from "../../../services/EPaymentConfig";
import * as sweetalert from "sweetalert";
import { getAllServices } from "../../../services/Services";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "التحويلات الواردة",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const AllLiretnaTransferFrom = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [users, setUsers] = useState([]);
  // const [pagination, setPagination] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [ToMobileTransction, setToMobileTransction] = useState("");
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  const [idPayment, setIdPayment] = React.useState();
  const [personName, setPersonName] = React.useState([]);
  const [selectedFundCompanies, setSelectedFundCompanies] = useState([]);
  const [orderType, setOrderType] = useState("");
  const [Calaculation, setCalaculation] = useState(0);
  const [ServicesData, setServices] = useState([]);

  const names = [
    "ليرتنا كاش",
    "وحدات Syriatel",
    "فاتورة Syriatel",
    "Syriatel كاش ",
    "وحدات MTN",
    "فاتورة MTN",
    "MTN كاش",
  ];
  const type_order = [
    { id: "prepaid", title: "مدفوع" },
    { id: "postpaid", title: "غير مدفوع" },
  ];
  const mobile_number_login = localStorage.getItem("mobile_number_login");
  const [mobileNumberLogin, setMobileNumberLogin] =
    useState(mobile_number_login);
  const [mobilefromNumberLogin, setMobilefromNumberLogin] = useState("");
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [Banks, setBanks] = useState([]);
  const [Paymentconfigration, setGetPaymentconfigration] = useState([]);
  const handlefilter = (event) => {
    if (personName.length == 0) {
      sweetalert("يجب اختيار اسم الرصيد", {
        className: "alert-div",
        button: {
          text: "تم",
        },
      }).then(() => {});
    } else {
      let mobile;
      if (orderType == "") {
        if (mobileNumberLogin == "0950555563") {
          mobile = mobilefromNumberLogin;
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length == 0
          ) {
            const data = {
              fund_name: personName,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            ToMobileTransction.length == 0 &&
            mobilefromNumberLogin.length != 0
          ) {
            const data = {
              fund_name: personName,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              fund_name: personName,
              mobile_to: ToMobileTransction,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length != 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              fund_name: personName,
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        } else {
          mobile = mobileNumberLogin;

          if (ToMobileTransction.length == 0) {
            const data = {
              fund_name: personName,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }

          if (ToMobileTransction.length != 0) {
            const data = {
              fund_name: personName,
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        }
      } else {
        if (mobileNumberLogin == "0950555563") {
          mobile = mobilefromNumberLogin;
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length == 0
          ) {
            const data = {
              fund_name: personName,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            ToMobileTransction.length == 0 &&
            mobilefromNumberLogin.length != 0
          ) {
            const data = {
              fund_name: personName,
              code_name: orderType,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              fund_name: personName,
              code_name: orderType,
              mobile_to: ToMobileTransction,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length != 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              fund_name: personName,
              code_name: orderType,
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        } else {
          mobile = mobileNumberLogin;

          if (ToMobileTransction.length == 0) {
            const data = {
              fund_name: personName,
              code_name: orderType,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }

          if (ToMobileTransction.length != 0) {
            const data = {
              fund_name: personName,
              code_name: orderType,
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
              page: pagination.current_page,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        }
      }
    }
  };
  const handleReload = (event) => {
    setPersonName([]);
    setOrderType([]);
    setMobilefromNumberLogin([]);
    setToMobileTransction([]);
    setCalaculation([]);
    setDateFrom("");
    setDateTo("");
    setIsLoading(true);

    const data = {
      page: pagination.current_page,
    };
    axios
      .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
        withCredentials: true,
      })
      .then((response) => {
        setUsers(response.data.data); // Setting users with response data
        setLoading(false);
        setPagination({
          ...pagination,
          total: response.data.pagination.total, // Total items count across all pages
          current_page: response.data.pagination.current_page,
          total_pages: response.data.pagination.total_pages,
          count: response.data.pagination.count,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        setUsers([]); // Setting users to an empty array in case of error
        setLoading(false);
      });
    return () => {};
  };
  const handleChange = (event) => {
    if (event.target.value.length === 0) {
      // axios
      //   .get(`${BaseUrl}/api/getAllTransactionforMe`, {
      //     withCredentials: true,
      //   })
      //   .then((res) => {
      //     setUsers(res.data.data);
      //     setIsLoading(false);
      //   })
      //   .catch((error) => {
      //     setIsLoading(false);
      //   });
    }
    if (event.target.name === "fund_name") {
      setPersonName(event.target.value);
      // if (orderType == "") {

      //   const selectedOptions = event.target.value;
      //   axios
      //     .get(`${BaseUrl}/api/getAllTransactionforMe`, {
      //       withCredentials: true,
      //     })
      //     .then((res) => {
      //       const data = res.data.data;

      //       const filteredData = data.filter((row) => {
      //         const filterByOrderType =
      //           orderType.length > 0 ? orderType.includes(row.code_name) : true;
      //         const filterByPersonName =
      //           selectedOptions.length > 0
      //             ? selectedOptions.includes(row.fund_name)
      //             : true;
      //         const filterByToMobileTransction =
      //           ToMobileTransction.length > 0
      //             ? ToMobileTransction.includes(row.to_mobile_number)
      //             : true;
      //         const filterByMobileNumberLogin =
      //           mobilefromNumberLogin.length > 0
      //             ? mobilefromNumberLogin.includes(row.from_mobile_number)
      //             : true;

      //         return (
      //           filterByOrderType &&
      //           filterByPersonName &&
      //           filterByToMobileTransction &&
      //           filterByMobileNumberLogin
      //         );
      //       });

      //       setUsers(filteredData);

      //       setIsLoading(false);
      //     })
      //     .catch((error) => {
      //       setIsLoading(false);
      //     });
      // } else {

      //   const selectedOptions = event.target.value;
      //   const order_type = orderType;
      //   axios
      //     .get(`${BaseUrl}/api/getAllTransactionforMe`, {
      //       withCredentials: true,
      //     })
      //     .then((res) => {
      //       const data = res.data.data;

      //       const filteredData = data.filter((row) => {
      //         const filterByOrderType =
      //           orderType.length > 0 ? orderType.includes(row.code_name) : true;
      //         const filterByPersonName =
      //           selectedOptions.length > 0
      //             ? selectedOptions.includes(row.fund_name)
      //             : true;
      //         const filterByToMobileTransction =
      //           ToMobileTransction.length > 0
      //             ? ToMobileTransction.includes(row.to_mobile_number)
      //             : true;
      //         const filterByMobileNumberLogin =
      //           mobilefromNumberLogin.length > 0
      //             ? mobilefromNumberLogin.includes(row.from_mobile_number)
      //             : true;

      //             return (
      //               filterByOrderType &&
      //               filterByPersonName &&
      //               filterByToMobileTransction &&
      //               filterByMobileNumberLogin
      //               );
      //             });
      //             setUsers(filteredData);

      //       setUsers(filteredData);
      //       setIsLoading(false);
      //     })
      //     .catch((error) => {
      //       setIsLoading(false);
      //     });
      // }
    }
    if (event.target.name === "order_type") {
      setOrderType(event.target.value);
      // if (personName == "") {
      //   const selectedOptions = event.target.value;
      //   axios
      //     .get(`${BaseUrl}/api/getAllTransactionforMe`, {
      //       withCredentials: true,
      //     })
      //     .then((res) => {
      //       const data = res.data.data;

      //       const filteredData = data.filter((row) => {
      //         const filterByOrderType =
      //           selectedOptions.length > 0
      //             ? selectedOptions.includes(row.code_name)
      //             : true;
      //         const filterByPersonName =
      //           personName.length > 0
      //             ? personName.includes(row.fund_name)
      //             : true;
      //         const filterByToMobileTransction =
      //           ToMobileTransction.length > 0
      //             ? ToMobileTransction.includes(row.to_mobile_number)
      //             : true;
      //         const filterByMobileNumberLogin =
      //           mobilefromNumberLogin.length > 0
      //             ? mobilefromNumberLogin.includes(row.from_mobile_number)
      //             : true;

      //         return (
      //           filterByOrderType &&
      //           filterByPersonName &&
      //           filterByToMobileTransction &&
      //           filterByMobileNumberLogin
      //         );
      //       });

      //       setUsers(filteredData);
      //       setIsLoading(false);
      //     })
      //     .catch((error) => {
      //       setIsLoading(false);
      //     });
      // } else {
      //   const selectedOptions = event.target.value;
      //   const order_type = personName;
      //   axios
      //     .get(`${BaseUrl}/api/getAllTransactionforMe`, {
      //       withCredentials: true,
      //     })
      //     .then((res) => {
      //       const data = res.data.data;

      //       const filteredData = data.filter((row) => {
      //         const filterByOrderType =
      //           selectedOptions.length > 0
      //             ? selectedOptions.includes(row.code_name)
      //             : true;
      //         const filterByPersonName =
      //           personName.length > 0
      //             ? personName.includes(row.fund_name)
      //             : true;
      //         const filterByToMobileTransction =
      //           ToMobileTransction.length > 0
      //             ? ToMobileTransction.includes(row.to_mobile_number)
      //             : true;
      //         const filterByMobileNumberLogin =
      //           mobilefromNumberLogin.length > 0
      //             ? mobilefromNumberLogin.includes(row.from_mobile_number)
      //             : true;

      //         return (
      //           filterByOrderType &&
      //           filterByPersonName &&
      //           filterByToMobileTransction &&
      //           filterByMobileNumberLogin
      //         );
      //       });

      //       setUsers(filteredData);
      //       setIsLoading(false);
      //     })
      //     .catch((error) => {
      //       setIsLoading(false);
      //     });
      // }
    }
    if (event.target.name === "from_mobile_number") {
      setMobilefromNumberLogin(event.target.value);

      // if (event.target.value.length == 0) {
      //   const selectedOptions = event.target.value;
      //   axios
      //     .get(`${BaseUrl}/api/getAllTransactionforMe`, {
      //       withCredentials: true,
      //     })
      //     .then((res) => {
      //       const data = res.data.data;

      //       const filteredData = data.filter((row) => {
      //         const filterByOrderType =
      //           orderType.length > 0 ? orderType.includes(row.code_name) : true;
      //         const filterByPersonName =
      //           personName.length > 0
      //             ? personName.includes(row.fund_name)
      //             : true;
      //         const filterBySelectedOptions =
      //           selectedOptions.length > 0
      //             ? selectedOptions.includes(row.from_mobile_number)
      //             : true;
      //         const filterByMobileNumberLogin =
      //         ToMobileTransction.length > 0
      //             ? ToMobileTransction.includes(row.to_mobile_number)
      //             : true;

      //         return (
      //           filterByOrderType &&
      //           filterByPersonName &&
      //           filterBySelectedOptions &&
      //           filterByMobileNumberLogin
      //         );
      //       });
      //       console.log(filteredData, "filteredData");
      //       setUsers(filteredData);
      //       setIsLoading(false);
      //     })
      //     .catch((error) => {
      //       console.error("Error fetching data:", error);
      //       setIsLoading(false);
      //     });
      // } else if (event.target.value.length == 10) {
      //   const selectedOptions = event.target.value;
      //   axios
      //     .get(`${BaseUrl}/api/getAllTransactionforMe`, {
      //       withCredentials: true,
      //     })
      //     .then((res) => {
      //       const data = res.data.data;

      //       const filteredData = data.filter((row) => {
      //         const filterByOrderType =
      //           orderType.length > 0 ? orderType.includes(row.code_name) : true;
      //         const filterByPersonName =
      //           personName.length > 0
      //             ? personName.includes(row.fund_name)
      //             : true;
      //             const filterBySelectedOptions =
      //             selectedOptions.length > 0
      //               ? selectedOptions.includes(row.from_mobile_number)
      //               : true;
      //           const filterByMobileNumberLogin =
      //           ToMobileTransction.length > 0
      //               ? ToMobileTransction.includes(row.to_mobile_number)
      //               : true;
      //         return (
      //           filterByOrderType &&
      //           filterByPersonName &&
      //           filterBySelectedOptions &&
      //           filterByMobileNumberLogin
      //         );
      //       });

      //       setUsers(filteredData);
      //       setIsLoading(false);
      //     })
      //     .catch((error) => {
      //       console.error("Error fetching data:", error);
      //       setIsLoading(false);
      //     });
      // }
    }
    if (event.target.name === "to_mobile_number") {
      setToMobileTransction(event.target.value);

      // if (event.target.value.length == 0) {
      //   const selectedOptions = event.target.value;
      //   axios
      //     .get(`${BaseUrl}/api/getAllTransactionforMe`, {
      //       withCredentials: true,
      //     })
      //     .then((res) => {
      //       const data = res.data.data;

      //       const filteredData = data.filter((row) => {
      //         const filterByOrderType =
      //           orderType.length > 0 ? orderType.includes(row.code_name) : true;
      //         const filterByPersonName =
      //           personName.length > 0
      //             ? personName.includes(row.fund_name)
      //             : true;
      //         const filterBySelectedOptions =
      //           selectedOptions.length > 0
      //             ? selectedOptions.includes(row.to_mobile_number)
      //             : true;
      //         const filterByMobileNumberLogin =
      //           mobilefromNumberLogin.length > 0
      //             ? mobilefromNumberLogin.includes(row.from_mobile_number)
      //             : true;

      //         return (
      //           filterByOrderType &&
      //           filterByPersonName &&
      //           filterBySelectedOptions &&
      //           filterByMobileNumberLogin
      //         );
      //       });
      //       console.log(filteredData, "filteredData");
      //       setUsers(filteredData);
      //       setIsLoading(false);
      //     })
      //     .catch((error) => {
      //       console.error("Error fetching data:", error);
      //       setIsLoading(false);
      //     });
      // } else if (event.target.value.length == 10) {
      //   const selectedOptions = event.target.value;
      //   axios
      //     .get(`${BaseUrl}/api/getAllTransactionforMe`, {
      //       withCredentials: true,
      //     })
      //     .then((res) => {
      //       const data = res.data.data;

      //       const filteredData = data.filter((row) => {
      //         const filterByOrderType =
      //           orderType.length > 0 ? orderType.includes(row.code_name) : true;
      //         const filterByPersonName =
      //           personName.length > 0
      //             ? personName.includes(row.fund_name)
      //             : true;
      //         const filterBySelectedOptions =
      //           selectedOptions.length > 0
      //             ? selectedOptions.includes(row.to_mobile_number)
      //             : true;
      //         const filterByMobileNumberLogin =
      //           mobilefromNumberLogin.length > 0
      //             ? mobilefromNumberLogin.includes(row.from_mobile_number)
      //             : true;

      //         return (
      //           filterByOrderType &&
      //           filterByPersonName &&
      //           filterBySelectedOptions &&
      //           filterByMobileNumberLogin
      //         );
      //       });

      //       setUsers(filteredData);
      //       setIsLoading(false);
      //     })
      //     .catch((error) => {
      //       console.error("Error fetching data:", error);
      //       setIsLoading(false);
      //     });
      // }
    }
  };
  const handleChangeprderType = (event) => {
    setOrderType(event.target.value);
    if (event.target.value.length === 0) {
      axios
        .get(`${BaseUrl}/api/getAllTransactionforMe`, {
          withCredentials: true,
        })
        .then((res) => {
          setUsers(res.data.data);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    } else {
      const selectedOptions = event.target.value;
      axios
        .get(`${BaseUrl}/api/getAllTransactionforMe`, {
          withCredentials: true,
        })
        .then((res) => {
          const filteredData = res.data.data.filter((row) =>
            selectedOptions.includes(row.code_name)
          );
          setUsers(filteredData);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };
  useEffect(() => {}, [idPayment]);

  useEffect(() => {
    setIsLoading(true);

    const data = {
      page: pagination.current_page,
    };
    axios
      .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
        withCredentials: true,
      })
      .then((response) => {
        setUsers(response.data.data); // Setting users with response data
        setLoading(false);
        setPagination({
          ...pagination,
          total: response.data.pagination.total, // Total items count across all pages
          current_page: response.data.pagination.current_page,
          total_pages: response.data.pagination.total_pages,
          count: response.data.pagination.count,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        setUsers([]); // Setting users to an empty array in case of error
        setLoading(false);
      });
    getAllServices()
      .then((res) => {
        setServices(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setServices([]);
        setIsLoading(false);
      });
    return () => {};
  }, []);
  useEffect(() => {
    getAllPaymentMethods().then((res) => {
      setPaymentMethod(res.data);
    });
    getAllBanks().then((res) => {
      setBanks(res);
    });
    getEPaymentConfig().then((res) => {
      setGetPaymentconfigration(res);

      // setIsLoading(true);
    });
    return () => {};
  }, []);
  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleConfirmPayment = (rowId) => {
    setConfirmDialog({
      isOpen: true,
      title: "اختر طريفة الدفع",
      subTitle: "لايمكن التراجع عن هذه العملية",
      onConfirm: () => {
        // Use params.row.id directly here or ensure it's passed correctly
      },
    });
    setIdPayment(rowId);
  };

  const columns = [
    {
      field: "staff_from",
      headerName: "المرسل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "staff_to",
      headerName: "المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "staff_to_type",
      headerName: "نوع المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "from_mobile_number",
      headerName: "رقم المرسل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "to_mobile_number",
      headerName: "رقم المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "fund_name",
      headerName: "اسم الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "fund_company",
      headerName: "رصيد الشركة",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_berfore",
      headerName: "الرصيد قبل ",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_berfore_from",
      headerName: "رصيد المرسل قبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_after_from",
      headerName: "رصيد المرسل بعد ",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_after",
      headerName: "الرصيد بعد ",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount",
      headerName: "كمية الرصيد ",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "code_name",
      headerName: "نوع الطلب",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
      renderCell: (params) => {
        const isActive = params.value === "prepaid";
        return isActive ? (
          <p style={{ color: "#403e3e", fontSize: "10px" }}>مدفوع</p>
        ) : (
          <p style={{ color: "#403e3e", fontSize: "10px" }}>غير مدفوع</p>
        );
      },
    },
    {
      field: "payment_method_ar",
      headerName: "طريقة الدفع",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "number_transfer",
      headerName: "رقم التحويلة",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },

    {
      field: "created_at",
      headerName: "تاريخ التحويلة",
      headerAlign: "center",
      align: "center",
      minWidth: 200,
      maxWidth: 200,
      editable: false,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      cellClassName: "actions",
      renderCell: (params) => {
        return params.row.payment_method === "Debt" ? (
          <Box>
            <>
              <button
                variant="contained"
                className="activationbtn7"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleConfirmPayment(params.row.id);
                }}
              >
                تحويل لمدفوع
              </button>
            </>

            <ConfirmDialogPaymentMethod
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
              id={idPayment}
              setPaymentMethod={setPaymentMethod}
              paymentMethod={paymentMethod}
              Banks={Banks}
              setBanks={setBanks}
              setGetPaymentconfigration={setGetPaymentconfigration}
              Paymentconfigration={Paymentconfigration}
            />
          </Box>
        ) : (
          <></>
        );
      },
    },
  ];
  // const [page, setPage] = useState(1);
  // const [pageSize, setPageSize] = useState(10);

  // useEffect(() => {
  //   // Fetch initial data
  //   fetchData(page, pageSize);
  // }, [page, pageSize]);

  // const fetchData = async (page, pageSize) => {
  //   try {
  //     const response = await axios.get(`${BaseUrl}/api/getAllTransactionforMe`, {
  //       params: {
  //         page

  //       },
  //       withCredentials: true,
  //     })
  //     .then((res) => {
  //       setUsers(res.data.data);
  //       setIsLoading(false);
  //     })
  //     .catch((err) => {
  //       setUsers([]);
  //       setIsLoading(false);
  //     });
  //   } catch (error) {
  //     console.error('Failed to fetch data:', error);
  //   }
  // };

  // const handlePageChange = (newPage) => {
  //   setPage(newPage);
  // };

  // const handlePageSizeChange = (newPageSize) => {
  //   setPageSize(newPageSize);
  // };
  const [pagination, setPagination] = useState({
    total_pages: 1,
    current_page: 1,
    total: 10, // Initially no total rows known
    count: 10, // Initially no total rows known
  });
  const [loading, setLoading] = useState(false);
  const [datefrom, setDateFrom] = useState();
  const [dateto, setDateTo] = useState();
  // useEffect(() => {
  //   setLoading(true);
  //   const data ={
  //     page:pagination.current_page
  //   }
  //   axios
  //   .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
  //     withCredentials: true,
  //   })
  //   .then(response => {
  //     setUsers(response.data.data); // Setting users with response data
  //     setLoading(false);
  //     setPagination({
  //       ...pagination,
  //       total: response.data.pagination.total, // Total items count across all pages
  //       current_page: response.data.pagination.current_page,
  //       total_pages: response.data.pagination.total_pages,
  //       count: response.data.pagination.count
  //     });

  //   })
  //   .catch(error => {
  //     console.error('Failed to fetch data:', error);
  //     setUsers([]); // Setting users to an empty array in case of error
  //     setLoading(false);

  //     });
  // }, [pagination.current_page]); // Dependency on current_page only

  useEffect(() => {
    setLoading(true);
    let CodeName;
    let mobile;
    if (orderType == "") {
      let data;

      if (personName.length == 0) {
        if (mobileNumberLogin == "0950555563") {
          mobile = mobilefromNumberLogin;
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length == 0
          ) {
            data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            ToMobileTransction.length == 0 &&
            mobilefromNumberLogin.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_to: ToMobileTransction,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length != 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        } else {
          mobile = mobileNumberLogin;

          if (ToMobileTransction.length == 0) {
            data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }

          if (ToMobileTransction.length != 0) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        }
      } else {
        if (mobileNumberLogin == "0950555563") {
          mobile = mobilefromNumberLogin;
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length == 0
          ) {
            data = {
              page: pagination.current_page,
              fund_name: personName,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            ToMobileTransction.length == 0 &&
            mobilefromNumberLogin.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_to: ToMobileTransction,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length != 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        } else {
          mobile = mobileNumberLogin;

          if (ToMobileTransction.length == 0) {
            data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }

          if (ToMobileTransction.length != 0) {
            const data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        }
      }
    } else {
      let data;
      if (personName.length == 0) {
        if (mobileNumberLogin == "0950555563") {
          mobile = mobilefromNumberLogin;
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length == 0
          ) {
            data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            ToMobileTransction.length == 0 &&
            mobilefromNumberLogin.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_from: mobile,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_to: ToMobileTransction,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length != 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        } else {
          mobile = mobileNumberLogin;

          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length == 0
          ) {
            data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            ToMobileTransction.length == 0 &&
            mobilefromNumberLogin.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_from: mobile,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_to: ToMobileTransction,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length != 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: ["ليرتنا كاش"],
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        }
      } else {
        if (mobileNumberLogin == "0950555563") {
          mobile = mobilefromNumberLogin;
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length == 0
          ) {
            data = {
              page: pagination.current_page,
              fund_name: personName,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            ToMobileTransction.length == 0 &&
            mobilefromNumberLogin.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_from: mobile,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_to: ToMobileTransction,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (
            mobilefromNumberLogin.length != 0 &&
            ToMobileTransction.length != 0
          ) {
            const data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        } else {
          mobile = mobileNumberLogin;

          if (
            mobilefromNumberLogin.length == 0 &&
            ToMobileTransction.length == 0
          ) {
            data = {
              page: pagination.current_page,
              fund_name: personName,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
          if (ToMobileTransction.length == 0) {
            const data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_from: mobile,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }

          if (ToMobileTransction.length != 0) {
            const data = {
              page: pagination.current_page,
              fund_name: personName,
              mobile_to: ToMobileTransction,
              mobile_from: mobile,
              code_name: orderType,
              from_date: datefrom,
              to_date: dateto,
            };
            axios
              .post(`${BaseUrl}/api/getAllTransactionforMe`, data, {
                withCredentials: true,
              })
              .then((response) => {
                setUsers(response.data.data); // Setting users with response data
                const totalAmount = response.data.data.reduce(
                  (acc, transaction) => acc + transaction.amount,
                  0
                );
                setCalaculation(response.data.total_amount_sum);
                setLoading(false);
                setPagination({
                  ...pagination,
                  total: response.data.pagination.total, // Total items count across all pages
                  current_page: response.data.pagination.current_page,
                  total_pages: response.data.pagination.total_pages,
                  count: response.data.pagination.count,
                });
              })
              .catch((error) => {
                console.error("Failed to fetch data:", error);
                setUsers([]); // Setting users to an empty array in case of error
                setLoading(false);
              });
          }
        }
      }
    }
  }, [pagination.current_page]);

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      current_page: newPage + 1,
    }));
  };
  const handleDateFromChange = (event) => {
    setDateFrom(event.target.value);
  };

  const handleDateToChange = (event) => {
    setDateTo(event.target.value);
  };
  const staff_type = localStorage.getItem("staff_type");
  return (
    <Box m="2px 5px 0px 5px">
      <Header />
      
      {ServicesData[6]?.name == "Transactions" &&
      ServicesData[6]?.is_active == 1 ? (
        <Box
          m="40px 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .css-2nsdx6 .MuiDataGrid-cell": {
              fontSize: "10px !important",
            },
            "& .name-column--cell": {
              color: colors.redAccent[1100],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.redAccent[1100],
              borderBottom: "none",
              fontSize: "10px !important",
            },
            "& .MuiDataGrid-cellContent": {
              fontSize: "10px !important",
              color: `${colors.grey[600]} !important`,
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.white[100],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.redAccent[1100],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <Grid style={{ display: "flex" }}>
            <FormControl style={{ width: "200px", marginRight: "20px" }}>
              <InputLabel
                id="demo-mutiple-checkbox-label"
                style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
              >
                فلترة حسب اسم الرصيد
              </InputLabel>
              <Select
                multiple
                value={personName}
                onChange={handleChange}
                input={<Input />}
                renderValue={(selected) => selected.join(", ")}
                name="fund_name"
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl style={{ width: "100px", marginRight: "20px" }}>
              <InputLabel
                id="demo-mutiple-checkbox-label1"
                style={{ color: "#297FB8", fontSize: "20px", width: "100px" }}
              >
                فلترة حسب نوع التحويل
              </InputLabel>
              <Select
                value={orderType}
                onChange={handleChange}
                input={<Input />}
                name="order_type"
              >
                {type_order.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {mobileNumberLogin === "0950555563" ? (
              <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
                <TextField
                  className="form-control mobile-control"
                  fullWidth
                  type="text"
                  margin="normal"
                  name="from_mobile_number"
                  onChange={handleChange}
                  value={mobilefromNumberLogin}
                  label="رقم المرسل"
                  sx={{
                    "& .MuiInputLabel-root": { fontSize: "1rem" },
                    "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                  }}
                />
              </Grid>
            ) : (
              <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
                <TextField
                  className="form-control mobile-control"
                  // fullWidth
                  type="text"
                  margin="normal"
                  name="from_mobile_number"
                  onChange={handleChange}
                  value={mobile_number_login}
                  disabled
                  label="رقم المرسل"
                  sx={{
                    "& .MuiInputLabel-root": { fontSize: "1rem" },
                    "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                  }}
                />
              </Grid>
            )}

            {/* <Grid item lg={2} md={2} sm={2} style={{marginRight:'10px'}}>
            <TextField
              className="form-control mobile-control"
              disabled
              fullWidth
              type="text"
              margin="normal"
              name="from_mobile_number"
              onChange={handleChange}
              value={mobile_number_login}
              label="رقم المرسل"
              sx={{
                "& .MuiInputLabel-root": { fontSize: "1rem" },

                "& .MuiOutlinedInput-root": { fontSize: "1rem" },
              }}
              // value={}
            />
          </Grid> */}
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px", marginLeft: "10px" }}
            >
              <TextField
                className="form-control mobile-control"
                // fullWidth
                type="text"
                margin="normal"
                name="to_mobile_number"
                label="رقم المستقبل"
                value={ToMobileTransction}
                onChange={handleChange}
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>

            <div className="divdate" style={{ width: "300px" }}>
              <div className="dateFrom" style={{ marginTop: "-9px" }}>
                <label htmlFor="dateFrom">من تاريخ:</label>
                <input
                  id="dateFrom"
                  type="date"
                  value={datefrom}
                  onChange={handleDateFromChange}
                />
              </div>
              <div className="dateTo" style={{ marginTop: "-9px" }}>
                <label htmlFor="dateTo">إلى تاريخ:</label>
                <input
                  id="dateTo"
                  type="date"
                  value={dateto}
                  onChange={handleDateToChange}
                />
              </div>
            </div>
            <Box className="div-btn-header" style={{ marginRight: "3%" }}>
              <Button
                variant="contained"
                className="btn-submit"
                color="secondary"
                onClick={() => {
                  handlefilter();
                }}
              >
                فلترة
              </Button>
            </Box>
            <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                label="النتيجة"
                onChange={handleChange}
                value={Calaculation}
                disabled
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>

            {/* <Box className="div-btn-header" style={{marginRight:'3%'}}> */}

            <Button
              style={{ marginRight: "3%" }}
              variant="contained"
              className="btn-submit"
              // color="secondary"
              onClick={() => {
                handleReload();
              }}
            >
              <ReplayIcon />
            </Button>
            {/* </Box> */}
          </Grid>
          <DataGridPro
            rows={users}
            className="field-table"
            style={{ fontSize: "10px" }}
            columns={columns}
            editMode="row"
            pageSize={10}
            rowCount={pagination.total} // Total number of rows
            pagination
            paginationMode="server" // Set pagination mode to server
            onPageChange={handlePageChange}
            page={pagination.current_page - 1} // Set the current page
            rowModesModel={rowModesModel}
            onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
            onRowEditStart={handleRowEditStart}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            components={{
              Toolbar: EditToolbar,
            }}
            localeText={{
              toolbarColumns: "الأعمدة",
              toolbarFilters: "الفلاتر",
              toolbarDensity: "التباعد",
              toolbarExport: "تصدير",
              filterPanelAddFilter: "إضافة فلتر",
              filterOperatorContains: "تحتوي",
              filterOperatorEquals: "تساوي",
              filterOperatorStartsWith: "تبدأ ب",
              filterOperatorEndsWith: "تنتهي  ب",
              filterOperatorIsAnyOf: "هو أي من",
              filterOperatorIsEmpty: "فارغ",
              filterOperatorIsNotEmpty: "غير فارغ",
              toolbarDensityCompact: "دمج",
              toolbarDensityStandard: "معيار",
              toolbarDensityComfortable: "مريح",
              toolbarExportCSV: "تصدير CSV",
              toolbarExportPrint: "طباعة",
              filterPanelInputLabel: "القيمة",
              filterPanelInputPlaceholder: "ادخل القيمة",
              filterPanelColumns: "الاعمدة",
              filterPanelOperators: "العمليات",
              columnsPanelTextFieldLabel: "بحث عن عمود",
              columnsPanelTextFieldPlaceholder: "عنوان العمود",
            }}
            componentsProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            experimentalFeatures={{ newEditingApi: true }}
          />
        </Box>
      ) : ServicesData[6]?.name == "Transactions" &&
        ServicesData[6]?.is_active == 0 && staff_type == "Admin" &&
                  mobile_number_login == "0950555563"? (
                    <Box
          m="40px 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .css-2nsdx6 .MuiDataGrid-cell": {
              fontSize: "10px !important",
            },
            "& .name-column--cell": {
              color: colors.redAccent[1100],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.redAccent[1100],
              borderBottom: "none",
              fontSize: "10px !important",
            },
            "& .MuiDataGrid-cellContent": {
              fontSize: "10px !important",
              color: `${colors.grey[600]} !important`,
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.white[100],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.redAccent[1100],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <Grid style={{ display: "flex" }}>
            <FormControl style={{ width: "200px", marginRight: "20px" }}>
              <InputLabel
                id="demo-mutiple-checkbox-label"
                style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
              >
                فلترة حسب اسم الرصيد
              </InputLabel>
              <Select
                multiple
                value={personName}
                onChange={handleChange}
                input={<Input />}
                renderValue={(selected) => selected.join(", ")}
                name="fund_name"
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl style={{ width: "100px", marginRight: "20px" }}>
              <InputLabel
                id="demo-mutiple-checkbox-label1"
                style={{ color: "#297FB8", fontSize: "20px", width: "100px" }}
              >
                فلترة حسب نوع التحويل
              </InputLabel>
              <Select
                value={orderType}
                onChange={handleChange}
                input={<Input />}
                name="order_type"
              >
                {type_order.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {mobileNumberLogin === "0950555563" ? (
              <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
                <TextField
                  className="form-control mobile-control"
                  fullWidth
                  type="text"
                  margin="normal"
                  name="from_mobile_number"
                  onChange={handleChange}
                  value={mobilefromNumberLogin}
                  label="رقم المرسل"
                  sx={{
                    "& .MuiInputLabel-root": { fontSize: "1rem" },
                    "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                  }}
                />
              </Grid>
            ) : (
              <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
                <TextField
                  className="form-control mobile-control"
                  // fullWidth
                  type="text"
                  margin="normal"
                  name="from_mobile_number"
                  onChange={handleChange}
                  value={mobile_number_login}
                  disabled
                  label="رقم المرسل"
                  sx={{
                    "& .MuiInputLabel-root": { fontSize: "1rem" },
                    "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                  }}
                />
              </Grid>
            )}

            {/* <Grid item lg={2} md={2} sm={2} style={{marginRight:'10px'}}>
            <TextField
              className="form-control mobile-control"
              disabled
              fullWidth
              type="text"
              margin="normal"
              name="from_mobile_number"
              onChange={handleChange}
              value={mobile_number_login}
              label="رقم المرسل"
              sx={{
                "& .MuiInputLabel-root": { fontSize: "1rem" },

                "& .MuiOutlinedInput-root": { fontSize: "1rem" },
              }}
              // value={}
            />
          </Grid> */}
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              style={{ marginRight: "10px", marginLeft: "10px" }}
            >
              <TextField
                className="form-control mobile-control"
                // fullWidth
                type="text"
                margin="normal"
                name="to_mobile_number"
                label="رقم المستقبل"
                value={ToMobileTransction}
                onChange={handleChange}
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>

            <div className="divdate" style={{ width: "300px" }}>
              <div className="dateFrom" style={{ marginTop: "-9px" }}>
                <label htmlFor="dateFrom">من تاريخ:</label>
                <input
                  id="dateFrom"
                  type="date"
                  value={datefrom}
                  onChange={handleDateFromChange}
                />
              </div>
              <div className="dateTo" style={{ marginTop: "-9px" }}>
                <label htmlFor="dateTo">إلى تاريخ:</label>
                <input
                  id="dateTo"
                  type="date"
                  value={dateto}
                  onChange={handleDateToChange}
                />
              </div>
            </div>
            <Box className="div-btn-header" style={{ marginRight: "3%" }}>
              <Button
                variant="contained"
                className="btn-submit"
                color="secondary"
                onClick={() => {
                  handlefilter();
                }}
              >
                فلترة
              </Button>
            </Box>
            <Grid item lg={2} md={2} sm={2} style={{ marginRight: "10px" }}>
              <TextField
                className="form-control mobile-control"
                fullWidth
                type="text"
                margin="normal"
                label="النتيجة"
                onChange={handleChange}
                value={Calaculation}
                disabled
                sx={{
                  "& .MuiInputLabel-root": { fontSize: "1rem" },
                  "& .MuiOutlinedInput-root": { fontSize: "1rem" },
                }}
              />
            </Grid>

            {/* <Box className="div-btn-header" style={{marginRight:'3%'}}> */}

            <Button
              style={{ marginRight: "3%" }}
              variant="contained"
              className="btn-submit"
              // color="secondary"
              onClick={() => {
                handleReload();
              }}
            >
              <ReplayIcon />
            </Button>
            {/* </Box> */}
          </Grid>
          <DataGridPro
            rows={users}
            className="field-table"
            style={{ fontSize: "10px" }}
            columns={columns}
            editMode="row"
            pageSize={10}
            rowCount={pagination.total} // Total number of rows
            pagination
            paginationMode="server" // Set pagination mode to server
            onPageChange={handlePageChange}
            page={pagination.current_page - 1} // Set the current page
            rowModesModel={rowModesModel}
            onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
            onRowEditStart={handleRowEditStart}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            components={{
              Toolbar: EditToolbar,
            }}
            localeText={{
              toolbarColumns: "الأعمدة",
              toolbarFilters: "الفلاتر",
              toolbarDensity: "التباعد",
              toolbarExport: "تصدير",
              filterPanelAddFilter: "إضافة فلتر",
              filterOperatorContains: "تحتوي",
              filterOperatorEquals: "تساوي",
              filterOperatorStartsWith: "تبدأ ب",
              filterOperatorEndsWith: "تنتهي  ب",
              filterOperatorIsAnyOf: "هو أي من",
              filterOperatorIsEmpty: "فارغ",
              filterOperatorIsNotEmpty: "غير فارغ",
              toolbarDensityCompact: "دمج",
              toolbarDensityStandard: "معيار",
              toolbarDensityComfortable: "مريح",
              toolbarExportCSV: "تصدير CSV",
              toolbarExportPrint: "طباعة",
              filterPanelInputLabel: "القيمة",
              filterPanelInputPlaceholder: "ادخل القيمة",
              filterPanelColumns: "الاعمدة",
              filterPanelOperators: "العمليات",
              columnsPanelTextFieldLabel: "بحث عن عمود",
              columnsPanelTextFieldPlaceholder: "عنوان العمود",
            }}
            componentsProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            experimentalFeatures={{ newEditingApi: true }}
          />
        </Box>
      ) : ServicesData[6]?.name == "Transactions" &&
        ServicesData[6]?.is_active == 0 ? (
        <div class="services-no-available">
          هذه الخدمة غير متاحة
          <img src="7703205.webp" />
        </div>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default AllLiretnaTransferFrom;
